/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Restrict results to / hide people held in the org's tenant pools.
 *
 * Ids are checked against the caller's org (and for include/exclude
 * overlap) by ``app.services.search.pool_scope``, which reports
 * ``INVALID_FILTER`` rather than a generic validation error.
 */
export interface PoolMembershipFilterSchema {
  /** @maxItems 10 */
  include?: string[];
  /** @maxItems 10 */
  exclude?: string[];
}
